import {
  CalendarDaysIcon,
  MapPinIcon,
  TagIcon,
  CurrencyDollarIcon,
} from "@heroicons/react/24/outline";
import ImageNotFound from "../../images/imagenotfound.jpg";
import { useTranslation } from "react-i18next";
import { HeartIcon } from "@heroicons/react/24/solid";

export default function EventCardPreview({
  name,
  date,
  location,
  price,
  imageUrl,
  isFundraiser = false,
  taxesIncluded = false,
}) {
  const { t } = useTranslation();

  function formatAddress(address) {
    if (!address) return "";

    // On découpe par virgules
    const parts = address.split(",").map((p) => p.trim());

    // On garde uniquement les 2 premiers (rue + ville)
    return parts.slice(0, 2).join(", ");
  }
  return (
    <div className="relative h-full">
      <div className="max-w-sm w-full bg-white rounded-lg shadow-md overflow-hidden flex flex-col h-full max-h-[350px]">
        {isFundraiser && (
          <div className="absolute top-3 left-3 group z-10">
            <div className="flex items-center gap-1 bg-[#FFD76A] text-[#3a3a3a] text-xs font-normal px-3 py-1 rounded-full shadow-sm">
              <HeartIcon className="w-4 h-4" />
              <span>{t("ticketing.fundraiser")}</span>
            </div>
            <div className="absolute top-full mt-1 left-0 bg-gray-800 text-white text-sm rounded-lg p-3 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity z-50 whitespace-wrap">
              {t("ticketing.fundraiserTooltip")}
            </div>
          </div>
        )}

        {/* Image EXEMPLE PARFAIT IMAGE*/}
        <div className="relative w-full h-36 overflow-x-auto overflow-y-hidden rounded-t-lg">
          <img
            src={imageUrl || ImageNotFound}
            alt={name}
            className="h-full w-auto"
          />
        </div>

        {/* Infos */}
        <div className="p-4 flex flex-col flex-grow">
          <h3 className="text-lg font-bold text-gray-900 line-clamp-2 min-h-[3.5rem]">
            {name || ""}
          </h3>

          <div className="flex items-center text-sm text-gray-600">
            <CalendarDaysIcon className="w-4 h-4 mr-2" />
            {date
              ? new Date(date).toLocaleDateString("fr-CA", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })
              : ""}
          </div>

          <a
            className="flex items-center text-sm text-gray-600 hover:underline"
            target="_blank"
            rel="noopener noreferrer"
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
              location.formattedAddress
            )}`}
          >
            <MapPinIcon className="w-4 h-4 mr-2" />
            {formatAddress(location.formattedAddress) || ""}
          </a>

          <div className="flex items-center text-sm text-gray-700 mt-auto">
            <CurrencyDollarIcon className="w-4 h-4 mr-2" />
            {price !== undefined ? `$${price}` : "Price"}
            <span className="ml-1 italic text-sm text-gray-400">
              {taxesIncluded
                ? t("ticketing.perTicketTaxesIncluded")
                : t("ticketing.perTicket")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
